import { sendRequest } from "../../hooks/requests/useRequest";


export async function saveConfigurationSurvey(
    payload
) {

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload)
    };

    const response = await sendRequest(
        requestOptions, `TemplateConfigurationSurvey/Create`
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data,
            msg: response.msg
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
    else if (response.code === 500)
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
    else
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
}



export async function getAllTemplateConfiguration() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `TemplateConfigurationSurvey/List`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}


export async function updateConfigurationSurvey(
    payload,
    id_template
) {

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload)
    };

    const response = await sendRequest(
        requestOptions, `TemplateConfigurationSurvey/Update/${id_template}`
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
    else
        return {
            code: response.code,
            data: response.data,
            msg: response.msg

        }
}


export async function deleteTemplateConfiguration(id_template) {
    const requestOptions = {
        method: "DELETE",
    };

    const response = await sendRequest(requestOptions, `TemplateConfigurationSurvey/DeleteTemplate/${id_template}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response?.data
        }
    else
        return {
            code: response.code,
            data: response?.data
        }
}

export async function enableTemplateConfiguration(id_template) {
    const requestOptions = {
        method: "POST",
    };

    const response = await sendRequest(requestOptions, `TemplateConfigurationSurvey/EnableConsent/${id_template}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response?.data
        }
    else
        return {
            code: response.code,
            data: response?.data
        }
}



export async function answerSurvey(_nimm) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `TemplateConfigurationSurvey/GetAnswers/${_nimm}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response?.data
        }
    else
        return {
            code: response.code,
            data: response?.data
        }
}



export async function updateClausesSurvey(payload) {

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload)
    };

    const response = await sendRequest(requestOptions, `TemplateConfigurationSurvey/UpdateClauses`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response?.data
        }
    else
        return {
            code: response.code,
            data: response?.data
        }

}
